import React from "react";
import SectionTitle from '../Title'
import { useLanguage } from '../../i18n';
import './style.scss'

// Import service images  
import checkBounce from '../../images/services/check-bounce.png'
import divorce from '../../images/services/divorce.jpg'
import contract from '../../images/services/contract.jpg'
import dispute from '../../images/services/dispute.jpeg'
import property from '../../images/services/property.jpg'
import criminal from '../../images/services/criminal.jpg'

const ServiceArea = ({ className }) => {
    const { t } = useLanguage();

    const redirectToContactArea = () => {
        window.location.href = '/contact';
    };

    const services = [
        {
            img: divorce,
            icon: 'flaticon-parents',
            titleKey: 'services.divorceTitle',
            contentKey: 'services.divorceDesc'
        },
        {
            img: checkBounce,
            icon: 'flaticon-wounded',
            titleKey: 'services.recoveryTitle',
            contentKey: 'services.recoveryDesc'
        },
        {
            img: dispute,
            icon: 'flaticon-employee',
            titleKey: 'services.corporateTitle',
            contentKey: 'services.corporateDesc'
        },
        {
            img: criminal,
            icon: 'flaticon-thief',
            titleKey: 'services.criminalTitle',
            contentKey: 'services.criminalDesc'
        },
        {
            img: contract,
            icon: 'flaticon-university-graduate-hat',
            titleKey: 'services.contractTitle',
            contentKey: 'services.contractDesc'
        },
        {
            img: property,
            icon: 'flaticon-house',
            titleKey: 'services.propertyTitle',
            contentKey: 'services.propertyDesc'
        },
    ];

    return (
        <>
            <div className={className}>
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <SectionTitle
                                title={t('services.title')}
                                subTitle={t('services.subtitle')}
                            />
                        </div>
                        {services.map((service, index) => (
                            <div key={index} className="col-lg-4 col-md-6" onClick={() => redirectToContactArea()}>
                                <div className="serviceWrap">
                                    <div className="serviceIcon">
                                        <img loading="lazy" decoding="async" src={service.img} alt="" />
                                    </div>
                                    <div className="serviceContent">
                                        <h3>{t(service.titleKey)}</h3>
                                        <p>{t(service.contentKey)}</p>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </>
    )
}
export default ServiceArea